<template>
  <b-modal
    centered
    :visible="reportWizardWindowVisible"
    title="Kreator raportów"
    no-close-on-backdrop
    no-close-on-esc
    size="lg"
    @hide="cancel">
    <step-counter :current-step="currentStep" :steps-count="stepsCount"></step-counter>
    <b-alert variant="danger" :show="validationErrors">
      <strong>Uwaga.</strong>
      Formularz zawiera błędy.
    </b-alert>
    <b-alert variant="danger" :show="!hasPermissionReportGeneration">
      <strong>Uwaga.</strong>
      Użytkownik nie ma uprawnień do generowania raportu.
    </b-alert>
    <b-alert variant="info" :show="rangeSelectionActive">
      <strong>Informacja.</strong>
      Nie zatwierdzono zasięgu.
    </b-alert>
    <report-wizard-step1 ref="step1" v-show="isVisible(currentStep, 1)" :formData="step1Model"></report-wizard-step1>
    <report-wizard-step2-map ref="step2mapReport" v-show="isVisible(currentStep, 2, 'mapReport')" :formData="mapReportModel"></report-wizard-step2-map>
    <report-wizard-step2-gis-data ref="step2gisReport" v-show="isVisible(currentStep, 2, 'gisReport')" :formData="gisReportModel"></report-wizard-step2-gis-data>
    <div slot="modal-footer" class="w-100 text-right">
      <b-btn type="button" variant="link" v-show="currentStep > 1" @click="previous" class="float-left px-0">Powrót</b-btn>
      <b-btn type="button" variant="primary" v-show="currentStep === 1" @click="next">Dalej</b-btn>
      <b-btn type="button" variant="primary" v-show="currentStep > 1" @click="saveToFile" :disabled="rangeSelectionActive || reportWizardLocked"><icon name="download"/> Pobierz</b-btn>
      <b-btn type="button" variant="secondary" v-show="currentStep > 1" @click="print" :disabled="rangeSelectionActive || reportWizardLocked"><icon name="print"/> Drukuj</b-btn>
      <b-btn type="button" variant="outline-secondary" @click="cancel">Anuluj</b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

import StepCounter from "../StepCounter";
import ReportWizardStep1 from "./ReportWizardStep1";
import ReportWizardStep2Map from "./ReportWizardStep2Map";
import ReportWizardStep2GisData from "./ReportWizardStep2GisData";

import SettingsInstance from "../../api/SettingsInstance";
import { Api as ApiReport } from "../../api/api-raporty";

import {
  WINDOW_REPORT_WIZARD_HIDE,
  WINDOW_REPORT_WIZARD_SHOW,
  WINDOW_NOTIFICATION_SHOW,
  WINDOW_API_ERROR_SHOW,
  REPORT_LOCKED_SET
} from "../../store/mutations.type";
import { REPORTS_SAVE, CLAUSES_FETCH } from "../../store/actions.type";

export default {
  name: "ReportWizard",
  components: {
    StepCounter,
    ReportWizardStep1,
    ReportWizardStep2Map,
    ReportWizardStep2GisData
  },
  data: function() {
    return {
      currentStep: 1,
      stepsCount: 2,
      steps: {
        "1": [""],
        "2": ["mapReport", "gisReport"]
      },
      validationErrors: false,
      printWindow: null,
      step1Model: {
        content: undefined
      },
      mapReportModel: {
        fileFormat: "pdf",
        title: undefined,
        description: undefined,
        dataRange: "full",
        colour: "niebieski",
        clause: "",
        elements: [],
        compression: "0,95",
        resolution: "200",
        coordinateSystem: "EPSG:2180",
        format: "A4",
        horizontalLayout: true,
        periodic: {
          periodicGeneration: false,
          date: undefined,
          time: undefined,
          frequency: "",
          repeats: undefined,
          email: undefined
        }
      },
      gisReportModel: {
        fileFormat: "xlsx",
        title: undefined,
        description: undefined,
        dataRange: "",
        colour: "",
        clause: "",
        coordinateSystem: "EPSG:2180",
        horizontalLayout: true,
        geometryFormat: "WKT",
        layout: "standard",
        attribute: "",
        periodic: {
          periodicGeneration: false,
          date: undefined,
          time: undefined,
          frequency: "",
          repeats: undefined,
          email: undefined
        }
      }
    };
  },
  computed: {
    ...mapGetters(["reportWizardWindowVisible", "rangeSelectionActive", "reportWizardLocked"]),
    hasPermissionReportGeneration() {
      return this.hasPermission('Report_generation');
    },
  },
  methods: {
    previous() {
      if (this.currentStep > 1) {
        this.currentStep--;
        this.validationErrors = false;
      }
    },
    async next() {
      if (this.currentStep < this.stepsCount) {
        if (await this.validateCurrentStep()) {
          this.currentStep++;
        }
      }
    },
    isPrintableFileFormat(file){
      return file.format_pliku!="docx" ? true : false;
    },
    async print() {
      if ((await this.validateCurrentStep()) && this.hasPermissionReportGeneration) {
        let data = this.getData();
      
        if(!this.isPrintableFileFormat(data)){
          this.saveToFile();
        }
        else{
          this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
            type: "info",
            title: "Informacja",
            message:
              "Trwa generacja raportu. Po zakończeniu raport będzie dostępny w magazynie raportów.",
            duration: 1000000
          });

          this.cancel();
          
          try {         
            let reportId = (await this.$store.dispatch(REPORTS_SAVE, data)).body
              .id;

            if(reportId && !data.aktywny) {
              var api = new ApiReport();
              var vm = this;
              var intervalId = setTimeout(async function askForStatus(){
                const control = Date.now().toString();
                var result = await api.getRaportyById({
                  control: control,
                  id: reportId
                });
                
            if(result && result.body.control == control && vm.hasPermissionReportGeneration) {
                  if(result.body.raporty.status.value == "generated") {
                    let reportUrl = await vm.getReportDownloadUrl(result.body.raporty.uuid, false);
                    
                    if (vm.printWindow) {
                      vm.printWindow.parentNode.removeChild(vm.printWindow);
                    }
 
                    vm.printWindow = document.createElement("iframe");
                    vm.printWindow.onload = vm.printNewLoadedWindow;
                    vm.printWindow.setAttribute("id", "reportFrame");
                    vm.printWindow.setAttribute("name", "reportFrame");
                    vm.printWindow.setAttribute("src", reportUrl);
                    vm.printWindow.setAttribute("style","display: none")
                    document.body.appendChild(vm.printWindow);
                  } else {
                    intervalId = setTimeout(askForStatus, 10000);
                  }
                }
              }, 0);
            }
          } catch (error) {
            this.$store.commit(WINDOW_API_ERROR_SHOW, error);
          }
        }
      }
    },
    printNewLoadedWindow() {
      window.frames["reportFrame"].focus();
      window.frames["reportFrame"].print();
    },
    async saveToFile() {
      if ((await this.validateCurrentStep()) && this.hasPermissionReportGeneration) {
        let data = this.getData();
        
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          type: "info",
          title: "Trwa generowanie raportu",
          message:
            "Po wygenerowaniu raportu ukaże się okno potwierdzające zapis. Raport będzie również dostępny w magazynie raportów.",
          duration: 1000000
        });

        this.cancel();

        try {       
          let reportId = (await this.$store.dispatch(REPORTS_SAVE, data)).body.id;
          if(reportId && !data.aktywny) {
            var api = new ApiReport();
            var vm = this;
            var intervalId = setTimeout(async function askForStatus(){
              const control = Date.now().toString();
              var result = await api.getRaportyById({
                control: control,
                id: reportId
              });
              if(result && result.body.control == control && vm.hasPermissionReportGeneration) {
                if(result.body.raporty.status.value == "generated") {
                  let reportUrl = await vm.getReportDownloadUrl(result.body.raporty.uuid, true);
                  window.location.href = reportUrl;
                } else {
                  intervalId = setTimeout(askForStatus, 1000);
                }
              }
            }, 0);
          }
        } catch (error) {
          this.$store.commit(WINDOW_API_ERROR_SHOW, error);
        }
      }
    },
    async getReportDownloadUrl(uuid, download) {
      let baseUrl = SettingsInstance.baseApiUrl.trim("/");
      baseUrl += "/raporty/by_uuid/" + uuid;
      baseUrl += "?download=" + download;
      return baseUrl;
    },
    getData() {
      let data = {};

      Object.assign(data, this.getVisibleStep(1).getData());
      Object.assign(data, this.getVisibleStep(2).getData());

      return data;
    },
    async validateCurrentStep() {
      this.$store.commit(REPORT_LOCKED_SET, true);
      let visibleStep = this.getVisibleStep(this.currentStep);
      this.validationErrors = !(await visibleStep.validate());
      this.$store.commit(REPORT_LOCKED_SET, false);
      return !this.validationErrors;
    },
    isVisible(currentStep, stepNumber, stepName) {
      if (currentStep !== stepNumber) {
        return false;
      }

      return !stepName || this.step1Model.content === stepName;
    },
    getVisibleStep(stepNumber) {
      const self = this;

      let currentStepName = self.steps[stepNumber].find(x =>
        self.isVisible(stepNumber, stepNumber, x)
      );
      let refKey = "step" + stepNumber + currentStepName;

      return self.$refs[refKey];
    },
    cancel() {
      if (this.reportWizardWindowVisible && !this.rangeSelectionActive) {
        this.currentStep = 1;
        this.$refs.step1.reset();
        this.$refs.step2mapReport.reset();
        this.$refs.step2gisReport.reset();
        this.validationErrors = false;
      }
      
      this.$store.commit(WINDOW_REPORT_WIZARD_HIDE);
    }
  },
  created() {
    const self = this;

    self.$store.watch(
      () => self.$store.getters.rangeSelectionActive,
      value => {
        if (value) {
          self.$store.commit(WINDOW_REPORT_WIZARD_HIDE);
        } else {
          self.$store.commit(WINDOW_REPORT_WIZARD_SHOW);
        }
      }
    );

    self.$store.dispatch(CLAUSES_FETCH);
  },
  watch: {
    hasPermissionReportGeneration(value) {
      if (this.reportWizardWindowVisible && !value) {
        this.cancel();
      }
    }
  }
};
</script>